'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'flux-capacitor';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8ba';
var svgPathData = 'M384 48c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48L64 464c-26.5 0-48-21.5-48-48L16 96c0-26.5 21.5-48 48-48l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM312 96c39.8 0 72 32.2 72 72s-32.2 72-72 72c-4.4 0-8 3.6-8 8s3.6 8 8 8c48.6 0 88-39.4 88-88s-39.4-88-88-88c-32.6 0-61 17.7-76.2 44c-2.2 3.8-.9 8.7 2.9 10.9s8.7 .9 10.9-2.9c12.5-21.5 35.7-36 62.4-36zM198.5 132c2.2 3.8 7.1 5.1 10.9 2.9s5.1-7.1 2.9-10.9c-15.2-26.3-43.6-44-76.2-44c-48.6 0-88 39.4-88 88s39.4 88 88 88c4.4 0 8-3.6 8-8s-3.6-8-8-8c-39.8 0-72-32.2-72-72s32.2-72 72-72c26.6 0 49.9 14.5 62.4 36zm-26 150.3c-3.2-3.1-8.2-3-11.3 .1C145.6 298.3 136 320 136 344c0 48.6 39.4 88 88 88s88-39.4 88-88c0-24-9.6-45.7-25.2-61.6c-3.1-3.2-8.2-3.2-11.3-.1s-3.2 8.2-.1 11.3c12.7 13 20.6 30.8 20.6 50.4c0 39.8-32.2 72-72 72s-72-32.2-72-72c0-19.6 7.8-37.4 20.6-50.4c3.1-3.2 3-8.2-.1-11.3zM133.7 154.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L216 259.3l0 92.7c0 4.4 3.6 8 8 8s8-3.6 8-8l0-92.7 93.7-93.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 244.7l-90.3-90.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFluxCapacitor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;